/** biome-ignore-all lint/suspicious/noConsole: we don't have logger here*/

import { AlertCircle } from 'lucide-react'
import { Button } from 'primitives/button'
import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Error caught by error boundary:', error, errorInfo)
  }

  render() {
    const { hasError, error } = this.state
    const { children, fallback } = this.props

    if (hasError) {
      if (fallback) return fallback

      return (
        <div className="flex flex-col items-center justify-center p-4 space-y-4 text-center">
          <AlertCircle className="w-8 h-8 text-destructive" />
          <div className="space-y-2">
            <h3 className="font-medium">Something went wrong</h3>
            <p className="text-sm text-muted-foreground">{error?.message}</p>
          </div>
          <Button
            variant="outline"
            onClick={() => this.setState({ hasError: false, error: undefined })}
          >
            Try again
          </Button>
        </div>
      )
    }

    return children
  }
}
